var map = {
	"./Argentina.png": 1871,
	"./Australia.png": 9070,
	"./Austria.png": 6657,
	"./Belarus.png": 8952,
	"./Belgium.png": 2839,
	"./Belize.png": 2843,
	"./Bolivia.png": 2732,
	"./Brazil.png": 532,
	"./Canada-1.png": 5762,
	"./Canada.png": 924,
	"./Channel Islands.png": 3151,
	"./Chile.png": 2063,
	"./Colombia.png": 7544,
	"./Costa-Rica.png": 8920,
	"./Czech Republic.png": 189,
	"./Czechia.png": 1471,
	"./Denmark.png": 4254,
	"./France.png": 3991,
	"./Germany.png": 6219,
	"./Ghana.png": 6077,
	"./Gibraltar.png": 260,
	"./Grenada.png": 2058,
	"./Guatemala.png": 1663,
	"./Guyana.png": 6759,
	"./India.png": 5449,
	"./Ireland.png": 4877,
	"./Italy.png": 7869,
	"./Japan.png": 8080,
	"./Latvia.png": 5367,
	"./Lithuania.png": 5657,
	"./Malaysia.png": 1451,
	"./Malta.png": 8943,
	"./Mexico.png": 3691,
	"./Netherlands.png": 7704,
	"./New Zealand.png": 3793,
	"./New-Zealand.png": 4462,
	"./Nicaragua.png": 1105,
	"./Nigeria.png": 8441,
	"./Peru.png": 7640,
	"./Philippines.png": 6981,
	"./Poland.png": 3974,
	"./Portugal.png": 8972,
	"./Saint Kitts and Nevis.png": 1916,
	"./Slovakia.png": 4858,
	"./Slovenia.png": 1407,
	"./South Africa.png": 113,
	"./South-Africa.png": 5660,
	"./Spain.png": 5719,
	"./Sri Lanka.png": 821,
	"./Sri-Lanka.png": 4390,
	"./St-Kitts-And-Nevis.png": 9107,
	"./Taiwan.png": 6058,
	"./Thailand.png": 7799,
	"./Ukraine.png": 627,
	"./United Kingdom.png": 9272,
	"./United States.png": 2513,
	"./United-Kingdom.png": 7527,
	"./United-States.png": 7428,
	"./Vatican City.png": 3467,
	"./Vatican-City.png": 8846,
	"./Venezuela.png": 1361,
	"./Zimbabwe.png": 8665
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9833;